var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSideNavigationOrdersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6201 9.62012H12.3701C11.9601 9.62012 11.6201 9.28012 11.6201 8.87012C11.6201 8.46012 11.9601 8.12012 12.3701 8.12012H17.6201C18.0301 8.12012 18.3701 8.46012 18.3701 8.87012C18.3701 9.28012 18.0401 9.62012 17.6201 9.62012Z",
    fill: "#0D0706"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.12006 10.3801C6.93006 10.3801 6.74006 10.3101 6.59006 10.1601L5.84006 9.41007C5.55006 9.12007 5.55006 8.64007 5.84006 8.35007C6.13006 8.06007 6.61006 8.06007 6.90006 8.35007L7.12006 8.57007L8.84006 6.85007C9.13006 6.56007 9.61006 6.56007 9.90006 6.85007C10.1901 7.14007 10.1901 7.62007 9.90006 7.91007L7.65006 10.1601C7.51006 10.3001 7.32006 10.3801 7.12006 10.3801Z",
    fill: "#0D0706"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6201 16.6201H12.3701C11.9601 16.6201 11.6201 16.2801 11.6201 15.8701C11.6201 15.4601 11.9601 15.1201 12.3701 15.1201H17.6201C18.0301 15.1201 18.3701 15.4601 18.3701 15.8701C18.3701 16.2801 18.0401 16.6201 17.6201 16.6201Z",
    fill: "#0D0706"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.12006 17.3801C6.93006 17.3801 6.74006 17.3101 6.59006 17.1601L5.84006 16.4101C5.55006 16.1201 5.55006 15.6401 5.84006 15.3501C6.13006 15.0601 6.61006 15.0601 6.90006 15.3501L7.12006 15.5701L8.84006 13.8501C9.13006 13.5601 9.61006 13.5601 9.90006 13.8501C10.1901 14.1401 10.1901 14.6201 9.90006 14.9101L7.65006 17.1601C7.51006 17.3001 7.32006 17.3801 7.12006 17.3801Z",
    fill: "#0D0706"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H15C20.43 1.25 22.75 3.57 22.75 9V15C22.75 20.43 20.43 22.75 15 22.75ZM9 2.75C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V9C21.25 4.39 19.61 2.75 15 2.75H9Z",
    fill: "#0D0706"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideNavigationOrdersIcon);
export default __webpack_public_path__ + "static/media/side-navigation-orders-icon.874eabf4c768e6f58c022546bef695dc.svg";
export { ForwardRef as ReactComponent };